// s88 (tog'a 2026-09-09, msg 1563): login/parolni FAQAT glavniy admin yoki «Логины и пароли» huquqi bor xodim beradi.
// Server (Helpers/LoginRights) bilan bir xil qoida; bu yerda faqat ekranni yashirish uchun.
import { isSuperAdmin } from "./hasPermission"

export function canManageLogins(user: any): boolean {
  if (!user) return false
  if (isSuperAdmin(user)) return true
  return user?.canManageLogins === true
}

export default canManageLogins
